import React, { use, useContext, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Button, Table, Card,InputGroup  } from 'react-bootstrap'
import { BiUpload } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../utils/Helper";

const Addmanager = () => {
    const { id } = useParams();
    const location = useLocation();
    const { row = {}} = location.state || {};
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
      profile_pic: row?.profile_pic || "",
      channel_partner_id: row?.channel_partner_id || "",
      first_name: row?.first_name || "",
      last_name: row?.last_name || "",
      email: row?.email || "",
      country_code: row?.country_code || "",
      mobile: row?.mobile || "",
      country_id: row?.country_id || "",
      region_id: row?.region_id || "",
      state_id: row?.state_id || "",
      city_id: row?.city_id || "",
      type_id: row?.type_id || "",
      category_id:row?.category_id || "",
      pin_code: row?.pin_code || "",
      description: row?.description || "",
  });
    const [imagePreview, setImagePreview] = useState(row?.profile_pic || null);
    const [rmTypeList, setRmTypeList] = useState([]);
    const [rmCategoryList, setRmCategoryList] = useState([]);
    const [channelPtNames,setChannelPtNames]= useState([])
    const [countries, setCountries] = useState([]);
    const [regions, setRegions] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [errors, setErrors] = useState({});
    const [load, setLoad] = useState(false);
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
    const authToken = process.env.REACT_APP_authToken;
    const { accessToken, logout } = useContext(UserContext);
    const headers = {
      "auth-token": authToken,
      authorization: accessToken,
      "content-type": "multipart/form-data",
    };

    useEffect(() => {
        fetchCountries();
        fetchRegions(101);
        fetchRmTypeList();
        fetchRmCategoryList()
        fetchChannelPtNamesList();
        if (id) {
          if(row?.region_id) fetchStates(row?.region_id);
          if(row?.region_id) fetchCities(row?.state_id);
        }
      }, [id]);

    const fetchCountries = async () => {
        try {
          const response = await APIServices.get(
            "/admin/cms/country_list",
            headers
          );
          if (response?.status === 200) {
            const countriesList = response?.data?.list || [];
            setCountries(countriesList);
            const india = countriesList.find(
              (country) => country.name.toLowerCase() === "india"
            );
            if (india) {
              setFormData((pre) => {
                if (!pre.country_code && india) {
                  return { ...pre, country_code: india.phonecode };
                }
                if (!pre.country_id && india) {
                  return { ...pre, country_id: india.id };
                }
                return pre;
              });
            }
          } else if (response?.status === 401) {
            logout();
            navigate("/");
          } else {
            setCountries([]);
          }
        } catch (error) {
          console.error("Error fetching countries:", error);
          setCountries([]);
        }
      };
    
    const fetchRegions = async (country_id) => {
    try {
        const response = await APIServices.get(
        `admin/cms/region_list/${country_id}`,
        headers
        );
        if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setRegions(countriesList);
        } else if (response?.status === 401) {
        logout();
        navigate("/");
        } else {
        setRegions([]);
        }
    } catch (error) {
        console.error("Error fetching regions:", error);
        setRegions([]);
    }
    };

    const fetchRmTypeList = async () => {
        try {
          const response = await APIServices.get(
            `admin/relationship_manager/type_list`,
            headers
          );
          if (response?.status === 200) {
            const countriesList = response?.data?.list || [];
            setRmTypeList(countriesList);
          } else if (response?.status === 401) {
            logout();
            navigate("/");
          } else {
            setRmTypeList([]);
          }
        } catch (error) {
          console.error("Error fetching regions:", error);
          setRmTypeList([]);
        }
      };
      const fetchRmCategoryList = async () => {
        try {
          const response = await APIServices.get(
            `admin/relationship_manager/category_list`,
            headers
          );
          if (response?.status === 200) {
            const categoryList = response?.data?.list || [];
            setRmCategoryList(categoryList);
          } else if (response?.status === 401) {
            logout();
            navigate("/");
          } else {
            setRmCategoryList([]);
          }
        } catch (error) {
          console.error("Error fetching category:", error);
          setRmCategoryList([]);
        }
      };
    const fetchChannelPtNamesList = async () => {
    try {
        const response = await APIServices.get(
        `admin/channel_partner/short_list?status=Active`,
        headers
        );
        if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setChannelPtNames(countriesList);
        } else if (response?.status === 401) {
        logout();
        navigate("/");
        } else {
        setChannelPtNames([]);
        }
    } catch (error) {
        console.error("Error fetching regions:", error);
        setChannelPtNames([]);
    }
    };  

    const fetchStates = async (regionId) => {
    try {
        const response = await APIServices.get(
        `/admin/cms/state_list/${regionId}`,
        headers
        );
        if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setStates(countriesList);
        } else if (response?.status === 401) {
        logout();
        navigate("/");
        } else {
        setStates([]);
        }
    } catch (error) {
        console.error("Error fetching states:", error);
    }
    };

    const fetchCities = async (stateId) => {
    try {
        const response = await APIServices.get(
        `/admin/cms/city_list/${stateId}`,
        headers
        );
        if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setCities(countriesList);
        } else if (response?.status === 401) {
        logout();
        navigate("/");
        } else {
        setCities([]);
        }
    } catch (error) {
        console.error("Error fetching cities:", error);
    }
    };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "profile_pic" && files.length > 0) {
          const file = files[0];
          setFormData((pre)=>({ ...pre, profile_pic: file }));
          const reader = new FileReader();
          reader.onloadend = () => setImagePreview(reader.result);
          reader.readAsDataURL(file);
        } else if (name === "mobile") {
          setFormData((pre)=>({ ...pre, [name]: value.replace(/[^0-9]/g, "") }));
        } else {
          setFormData((pre)=>({ ...pre, [name]: value }));
        }
        if (name === "region_id") {
          setFormData((pre)=>({ ...pre, state_id : "",city_id  : "" }));
          fetchStates(value);
        }
        if (name === "state_id") {
          setFormData((pre)=>({ ...pre,city_id  : "" }));
          fetchCities(value);
        }
        setErrors({ ...errors, [name]: "" });
      };

      const validate = () => {
        const newErrors = {};
        if (!formData.channel_partner_id)
          newErrors.channel_partner_id = "Channel partner name is required.";
      
        if (!formData.first_name)
          newErrors.first_name = "First name is required.";
      
        if (!formData.last_name)
          newErrors.last_name = "Last name is required.";
      
        if(formData.email != ""){
          if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
          }
        }
      
        if(formData.mobile != ""){
          if (!/^\d{10}$/.test(formData.mobile)) {
            newErrors.mobile = "Phone number is invalid (must be 10 digits).";
          }
        }
      
        if (!formData.pin_code) {
          newErrors.pin_code = "Pincode is required.";
        } else if (!/^\d{6}$/.test(formData.pin_code)) {
          newErrors.pin_code = "Pincode is invalid (must be 6 digits).";
        }
      
        if (!formData.region_id)
          newErrors.region_id = "Region is required.";
      
        if (!formData.state_id)
          newErrors.state_id = "State is required.";
      
        if (!formData.city_id)
          newErrors.city_id = "City is required.";
      
        if (!formData.category_id)
          newErrors.category_id = "Relationship manager category is required.";

        return newErrors;
      };

      
    const handleSubmit = async (e) => {
      e.preventDefault();
      const validationErrors = validate();

      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
      } else {
        setLoad(true);
        const formDataToSubmit = new FormData();
        Object.keys(formData).forEach((key) => {
          formDataToSubmit.append(key, formData[key]);
        });

        try {
          if (id) {
            const updateFormData = { ...formData };
            updateFormData.id = id;
            const res = await APIServices.post(
              `/admin/relationship_manager/update`,
              updateFormData,
              { "content-type": "multipart/form-data", ...headers }
            );
            if (res?.data?.status === true) {
              showToast(res?.data?.message || "Success", "success");
              setTimeout(() => {
                navigate("/admin/rm-list");
              }, 2000);
            } else if (res?.status === 401) {
              logout();
              navigate("/");
            } else {
              showToast(res?.data?.message || "Something went wrong.", "error");
            }
          } else {
            const response = await APIServices.post(
              `/admin/relationship_manager/add`,
              formDataToSubmit,
              { "content-type": "multipart/form-data", ...headers }
            );
            if (response?.data?.status === true) {
              showToast(response?.data?.message || "Success", "success");
              setTimeout(() => {
                navigate("/admin/rm-list");
              }, 2000);
            } else if (response?.status === 401) {
              logout();
              navigate("/");
            } else {
              showToast(
                response?.data?.message || "Something went wrong.",
                "error"
              );
            }
          }
        } catch (error) {
          showToast("Something went wrong.", "error");
        }finally{
          setLoad(false);
        }
      }
    };

    const showToast = (message, type) => {
    toast(message, {
        position: "top-right",
        autoClose: 2000,
        type,
        hideProgressBar: false,
        closeOnClick: true,
    });
    };  

    return (
        <>
            <div className='add_channel_sec add_rm_sec'>

                <div className="addmom_header d-flex justify-content-start mb-3">
                    <h1 className='font_blue_18 font-600'>
                    {id ? "Update Relationship Management" : "Add Relationship Management"}
                    </h1>
                </div>

                <Card className="add_channel_form">

                    <Card.Body>
                        <Form className="">


                            <Row>
                                <Col md={12} lg={12}>
                                    <div className="d-flex flex-column ">
                                        <label htmlFor="upload-input" className="upload-circle">
                                            {imagePreview ? (
                                                <img src={imagePreview} alt="Uploaded" className="uploaded-img" />
                                            ) : (
                                                <BiUpload size={30} color="#333" />
                                            )}
                                        </label>
                                        <Form.Control
                                            type="file"
                                            name="profile_pic"
                                            id="upload-input"
                                            className="d-none"
                                            accept="image/*"
                                            onChange={handleChange}
                                            ref={fileInputRef}
                                            isInvalid={!!errors.profile_pic}
                                                                />
                                        <p className="mt-2 font_blue_14">Upload Logo</p>
                                    </div>
                                    {errors.profile_pic && (
                                        <div className="text-danger">{errors.profile_pic}</div>
                                    )}
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="firstName">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">First Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter First Name"
                                            name="first_name"
                                            value={formData.first_name}
                                            onChange={handleChange} 
                                        />
                                    </Form.Group>
                                    {errors.first_name && (
                                    <div className="text-danger">{errors.first_name}</div>
                                    )}
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="lastName">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Last Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Last Name"
                                            name="last_name"
                                            value={formData.last_name}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                    {errors.last_name && (
                                    <div className="text-danger">{errors.last_name}</div>
                                    )}
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="emailId">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Email ID</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter Email ID"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                    {errors.email && (
                                    <div className="text-danger">{errors.email}</div>
                                    )}
                                </Col>

                                <Col md={6} lg={6}>
                                    <Form.Group controlId="country_code">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Phone No</Form.Label>
                                        <InputGroup>
                                          <Form.Select
                                            name="country_code"
                                            value={formData.country_code || "+91"} 
                                            onChange={handleChange}
                                            style={{ maxWidth: "140px", borderWidth:"0px" }} 
                                            disabled
                                          >
                                            {countries.map((country, index) => (
                                              <option key={country.id} value={country.phonecode}>
                                                {country.name} ({country.phonecode})
                                              </option>
                                            )
                                            )}
                                          </Form.Select>
                                          <Form.Control
                                              type="text"
                                              placeholder="Enter Phone No"
                                              name="mobile"
                                              value={formData.mobile}
                                              onChange={handleChange}
                                          />
                                        </InputGroup>
                                    </Form.Group>
                                    {errors.mobile && (
                                    <div className="text-danger">{errors.mobile}</div>
                                    )}
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="region">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Region</Form.Label>
                                        <Form.Select name="region_id" value={formData.region_id} onChange={handleChange}>
                                            <option value="">Select Region</option>
                                            {regions.map((region) => (
                                                <option key={region.id} value={region.id}>
                                                {capitalizeFirstLetter(region.name)}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.region_id && (
                                        <div className="text-danger">{errors.region_id}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="state">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">State</Form.Label>
                                        <Form.Select name="state_id" value={formData.state_id} onChange={handleChange}>
                                            <option value="">Select State</option>
                                            {states.map((state) => (
                                                <option key={state.id} value={state.id}>
                                                {capitalizeFirstLetter(state.name)}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.state_id && (
                                        <div className="text-danger">{errors.state_id}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="City">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">City</Form.Label>
                                        <Form.Select name="city_id" value={formData.city_id} onChange={handleChange}>
                                            <option value="">Select City</option>
                                            {cities.map((city) => (
                                            <option key={city.id} value={city.id}>
                                                {capitalizeFirstLetter(city.name)}
                                            </option>
                                            ))}
                                        </Form.Select>
                                        {errors.city_id && (
                                        <div className="text-danger">{errors.city_id}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="Pincode">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Pincode</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            placeholder="Enter Pincode"
                                            name="pin_code"
                                            value={formData.pin_code}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                    {errors.pin_code && (
                                        <div className="text-danger">{errors.pin_code}</div>
                                        )}
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="rm">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Type of Relationship Manager</Form.Label>
                                        <Form.Select name="type_id" value={formData.type_id} onChange={handleChange}>
                                            <option value={""}>Select Type of Relationship Manager</option>
                                            {rmTypeList.map((rmTypeList) => (
                                                <option
                                                key={rmTypeList.id}
                                                value={rmTypeList.id}
                                                >
                                                {capitalizeFirstLetter(rmTypeList.name)}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.type_id && (
                                        <div className="text-danger">{errors.type_id}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="rm_category">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Category of Relationship Manager</Form.Label>
                                        <Form.Select name="category_id" value={formData.category_id} onChange={handleChange}>
                                            <option>Select Category of Relationship Manager</option>
                                            {rmCategoryList.map((rmCategoryList) => (
                                                <option
                                                key={rmCategoryList.id}
                                                value={rmCategoryList.id}
                                                >
                                                {capitalizeFirstLetter(rmCategoryList.name)}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.category_id && (
                                        <div className="text-danger">{errors.category_id}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={6} lg={6}>
                                    <Form.Group controlId="state">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Channel Partner Name</Form.Label>
                                        <Form.Select name="channel_partner_id" value={formData.channel_partner_id} onChange={handleChange}>
                                            <option>Select Channel Partner Name</option>
                                            {channelPtNames.map((channelPtNames) => (
                                                <option
                                                key={channelPtNames.id}
                                                value={channelPtNames.id}
                                                >
                                                {capitalizeFirstLetter(channelPtNames.name)}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.channel_partner_id && (
                                        <div className="text-danger">{errors.channel_partner_id}</div>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={12} lg={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font_blue_14 font-500 mb-2 ">Description</Form.Label>
                                        <Form.Control    
                                            as="textarea"
                                            rows={3}
                                            placeholder="Write here..."
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            style={{ height: "120px" }}
                                        />
                                    {errors.description && (
                                        <div className="text-danger">{errors.description}</div>
                                    )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end gap-2">
                                <Button className="btn blue_border"
                                onClick={() => navigate("/admin/rm-list")}
                                >Cancel</Button>
                                <Button className="btn red_button"
                                onClick={handleSubmit}
                                disabled={load}
                                >
                                  {load ? "Processing..." : id ? "Update" : "Add"}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
            <ToastContainer />
        </>
    )
}

export default Addmanager
